<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="10" xs="10" sm="8" md="8" lg="8" class="vertical-no-padding-col">
        <TitleLabel :title="title" />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" xs="12" sm="8" md="8" lg="8" v-if="isOtherTeam">
        <OtherTeamPointLabelArea
          :user-name="userName"
          :team-name="teamName"
          :user-points="fetchedUserPoints"
          :team-points="fetchedTeamPoints"
          @openDetailIndividual="openIndividualChart"
          @openDetailTeam="openTeamChart"
        />
      </v-col>
      <v-col cols="12" xs="12" sm="8" md="8" lg="8" v-else>
        <PointLabelArea
          :user-name="userName"
          :team-name="teamName"
          :user-points="fetchedUserPoints"
          :team-points="fetchedTeamPoints"
          @openDetailIndividual="openIndividualChart"
          @openDetailTeam="openTeamChart"
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" xs="12" sm="10" md="10" lg="8">
        <v-overlay absolute :value="overlay" color="rgba(0,0,0,0)">
          <ChartCard
            :chart-title="chartTitle"
            :annotation-text="annotationText"
            :fetched-data="fetchedData"
            @closeClickAction="closeChart"
            red-text
          />
        </v-overlay>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" xs="12" sm="8" md="8" lg="8">
        <PointRanking :done-ecos-ranking="doneEcosRanking" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TitleLabel from "../Atoms/TitleLabel";
import PointLabelArea from "../Organisms/PointLabelArea";
import OtherTeamPointLabelArea from "../Organisms/OtherTeamPointLabelArea";
import PointRanking from "../Organisms/PointRanking";
import ChartCard from "../Organisms/ChartCard";
import errorHandle from "../../util/errorHandle.js";

export default {
  name: "Point",
  data: () => ({
    userId:"",
    teamId:"",
    userName: "",
    accessToken:"",
    userAuthority:"",
    teamName:"",
    title: "ポイント情報",
    overlay: false,
    annotationText: "",
    chartTitle: "",
    isOpenUserChart: true,
    fetchedUserPoints: [],
    fetchedTeamPoints:[],
    doneEcosRanking:[]
  }),
  created() {
    this.fetchInitialData();
    this.fetchEcoRanking()
  },
  mounted() {
    this.initIcon();
    this.getTeams();
    this.fetchUserPoint();
    this.fetchTeamPoint()
  },
  methods: {
    fetchInitialData() {
      const team_info = this.$store.getters["team/getTeamInfo"];
      this.teamId = team_info.teamId;

      const user_info = this.$store.getters["user/getUserInfo"];
      this.userId = user_info.userId;
      this.userName = user_info.userName;
      this.accessToken = user_info.accessToken;
      this.userAuthority = user_info.userAuthority;
    },
    initIcon() {
      this.$emit("initIcon");
    },
    openIndividualChart() {
      this.annotationText = "";
      this.chartTitle = `今週の${this.userName}`;
      this.overlay = !this.overlay;
      this.isOpenUserChart = true
    },
    openTeamChart() {
      this.annotationText =
        "※１週間のチーム全員の合計点に応じて、水槽の様子が変化します。";
      this.chartTitle = `今週の${this.teamName}`;
      this.overlay = !this.overlay;
      this.isOpenUserChart = false
    },
    closeChart() {
      this.overlay = false;
    },
    getTeams() {
      return new Promise((resolve, reject) => {
        const header = {
          headers: {
            Authorization: `Bearer ${this.accessToken}`
          }
        };
        this.axios
          .get(`/api/teams?team_id=${this.teamId}`, header)
          .then(response => {
            if (!response.data.teams.length) {
              return
            }
            this.teamName = response.data.teams[0].name;
            resolve();
          })
          .catch(error => {
            errorHandle
              .errorHandle(this, error)
              .then(() => {
                this.fetchInitialData();
                this.getTeams();
              })
              .catch(function(error) {
                console.log("エラーハンドリング失敗。エラー内容：", error);
              });
            console.log(error);
            reject();
          });
      });
    },
    fetchUserPoint() {
      return new Promise((resolve, reject) => {
        const header = {
          headers: {
            Authorization: `Bearer ${this.accessToken}`
          }
        };
        this.axios
          .get(`/api/points?user_id=${this.userId}`, header)
          .then(response => {
            this.fetchedUserPoints = response.data.points;
          })
          .catch(error => {
            errorHandle
              .errorHandle(this, error)
              .then(() => {
                this.fetchInitialData();
                this.fetchUserPoint();
              })
              .catch(function(error) {
                console.log("エラーハンドリング失敗。エラー内容：", error);
              });
            console.log(error);
            reject();
          });
      });
    },
    fetchTeamPoint() {
      return new Promise((resolve, reject) => {
        const header = {
          headers: {
            Authorization: `Bearer ${this.accessToken}`
          }
        };
        this.axios
          .get(`/api/points?team_id=${this.teamId}`, header)
          .then(response => {
            this.fetchedTeamPoints = response.data.points;
          })
          .catch(error => {
            errorHandle
              .errorHandle(this, error)
              .then(() => {
                this.fetchInitialData();
                this.fetchTeamPoint();
              })
              .catch(function(error) {
                console.log("エラーハンドリング失敗。エラー内容：", error);
              });
            console.log(error);
            reject();
          });
      });
    },
    fetchEcoRanking() {
      return new Promise((resolve, reject) => {
        const header = {
          headers: {
            Authorization: `Bearer ${this.accessToken}`
          }
        };
        this.axios
          .get(`/api/ranking_done_ecos?team_id=${this.teamId}`, header)
          .then(response => {
            this.doneEcosRanking = response.data.done_ecos;
          })
          .catch(error => {
            errorHandle
              .errorHandle(this, error)
              .then(() => {
                this.fetchInitialData();
                this.fetchEcoRanking();
              })
              .catch(function(error) {
                console.log("エラーハンドリング失敗。エラー内容：", error);
              });
            console.log(error);
            reject();
          });
      });
    },
  },
  computed:{
    isOtherTeam() {
      switch (this.$route.path) {
        case '/point':
          return false
        case '/other/point':
          return true
      }
      return false
    },
    fetchedData() {
      if (this.isOpenUserChart) {
        return this.fetchedUserPoints
      } else {
        return this.fetchedTeamPoints
      }
    }
  },
  components: {
    TitleLabel,
    PointLabelArea,
    OtherTeamPointLabelArea,
    PointRanking,
    ChartCard
  },
  head: {
    title: {
      inner: "point"
    }
  }
};
</script>

<style scoped>
.vertical-no-padding-col {
  padding: 0 12px;
}
</style>
